module.exports = __webpack_public_path__ + "img/file.731393c4.svg";